import { FileModel, FileSource } from '@aiwyn/shared';

import { ClientRequestDocumentFileDisplay } from '../../../../../models';

export interface DocumentPreviewList {
  files: FileModel[];
  initialIndex: number;
}

export function buildDocumentPreviewList(
  files: ClientRequestDocumentFileDisplay[] | null | undefined,
  clicked: ClientRequestDocumentFileDisplay,
): DocumentPreviewList {
  const previewable = (files?.length ? files : [clicked]).filter((file) => !file.isMasked && file.dmsId);
  const previewFiles = previewable.map((file) => ({
    id: file.id,
    name: file.name,
    fileSource: FileSource.CLIENT_REQUEST,
    dmsFileId: file.dmsId,
  }));
  const initialIndex = Math.max(
    0,
    previewable.findIndex((file) => file.id === clicked.id),
  );
  return { files: previewFiles, initialIndex };
}
